import React from "react";
import get from "lodash/get";
import { availableFeedCardPostTypes } from "../../../../utils/commonVariables";
import MetaBar from "../common/MetaBar";
import PostComments from "../common/PostComments";
import { Link } from "react-router-dom";
import {
    decodeString,
} from "../../../../utils/helper";
import { certificateLinks } from "../../../../utils/internalLinks";
import ReadMoreLinkified from "../common/ReadMoreLinkified";
import PaidRibbon from "../../../../components/profile/MyPassbook/PaidRibbon";
import CertificateStarGIF from "../../../../assets/images/certifications/certificate-star.gif";
import LazyLoadImageComponent from "../../../../components/misc/LazyLoadImageComponent";
function CertificateCard(props) {
    const {
        cardData,
        isShared,
        showOptionsIcon,
        hideMetaBar,
        isAd,
        commentsData,
    } = props,
        { certificate, meta } = cardData,
        postId = get(certificate, "id"),
        title = decodeString(certificate.title);
    const linkToCertificate = certificateLinks.viewCertificate(postId);
    const imageToShow = get(certificate, "image", "");
    const isPaid = get(meta, "isPaid", "");
    const date = get(certificate, "test_date", "");
    return (
        <div className="feed-card ">
            <Link to={linkToCertificate} className="certification__card certificate">

                {imageToShow ? (
                    <LazyLoadImageComponent
                        width={"auto"}
                        height={"auto"}
                        src={imageToShow}
                        alt={title}
                        className="certification__card__img"
                    />
                ) : null}
                <div className="certification__card__details flex cursor-pointer">
                    <div className="left">
                        {isPaid && (
                            <div className="feedcardribbon__certification__ribbon">
                                <PaidRibbon />
                            </div>
                        )}
                        <ReadMoreLinkified
                            text={title}
                            linksAsDiv={true}
                            className="certification__card__title"
                            hashtagEventLabel="Survey"
                        />
                        <p className="certification__card__subdetails">Issued On: <span>{date}</span></p>
                        <p className="certification__card__subdetails">Validity: <span>{get(certificate, "validity", "")}</span></p>
                    </div>
                    <div className="right">
                        <button className="certification__card__btn certificate-btn cursor-pointer">VIEW CERTIFICATE</button>
                        <img src={CertificateStarGIF} className="img" />
                    </div>
                </div>
            </Link>
            {!isShared && !hideMetaBar && cardData.meta && (
                <MetaBar
                    postType={availableFeedCardPostTypes.survey}
                    postId={postId}
                    isAd={isAd}
                    likeActionProcessing={cardData.likeActionProcessing}
                    fetchingComments={commentsData && commentsData.fetching}
                    postToShare={cardData}
                    meta={cardData.meta}
                />
            )}
            {commentsData && !hideMetaBar && !isShared && (
                <PostComments
                    showOptionsIcon={showOptionsIcon}
                    commentsData={commentsData}
                    postType={availableFeedCardPostTypes.survey}
                    isAd={isAd}
                    postId={postId}
                />
            )}
        </div>

    )
}


export default CertificateCard;